import {
  ACTION_GET_EXCLUSIVE_HOTELS,
  ACTION_GET_EXCLUSIVE_HOTELS_SUCCESS,
  ACTION_GET_EXCLUSIVE_HOTELS_FAILURE,
  ACTION_RESET_EXCLUSIVE_HOTELS,
  ACTION_RESET_EXCLUSIVE_HOTELS_SUCCESS,
  API_CALL,
} from '../../../configs/ActionTypes';

import * as _ from 'lodash-es';

import { Dispatch } from 'redux';

import { enqueueSnackbarHandler } from '../../Status';

export function get() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch(requestStarted());

    //Dispatch the api call request.
    dispatch({
      type: API_CALL,
      payload: {
        call: 'exclusive-hotels',
        method: 'get',
        data: {},
        success: (response: any) => {
          if (response.type === 'error') {
            enqueueSnackbarHandler(dispatch, response.payload.payload, 'error');
            dispatch(requestFailed(response));
          } else {
            dispatch(requestSuccess(response));
          }
        },
        fail: (error: any) => {
          if (error.payload) {
            enqueueSnackbarHandler(dispatch, error.payload, 'error');
          }
          dispatch(requestFailed(error));
        },
      },
    });

    return null;
  };
}

export function requestStarted() {
  return {
    type: ACTION_GET_EXCLUSIVE_HOTELS,
    payload: null,
  };
}

export function requestSuccess(responseJSON: object) {
  return {
    type: ACTION_GET_EXCLUSIVE_HOTELS_SUCCESS,
    payload: responseJSON,
  };
}

export function requestFailed(responseJSON: object) {
  return {
    type: ACTION_GET_EXCLUSIVE_HOTELS_FAILURE,
    payload: responseJSON,
  };
}

export function resetExlusiveHotels() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_RESET_EXCLUSIVE_HOTELS,
      payload: null,
    });
  };
}

export function resetExlusiveHotelsSuccess() {
  return (dispatch: Dispatch, getState: Function) => {
    dispatch({
      type: ACTION_RESET_EXCLUSIVE_HOTELS_SUCCESS,
      payload: null,
    });
  };
}
